
module.exports.DEFAULT_ENDPOINT = 'https://api.mapbox.com';



//////////////////
// WEBPACK FOOTER
// ./~/mapbox/lib/constants.js
// module id = 743
// module chunks = 2